// extracted by css-extract-rspack-plugin
export default {"jobTypes":"jobTypes-Cs6FO8","applicationStatus":"applicationStatus-YtIPaj","active":"active-zn8kEM","inReview":"inReview-TDmmA3"};